(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["juitoy-blog-latest"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__juitoyGuideArticlesV3) return;
    window.__juitoyGuideArticlesV3 = true;

    const mobileBreakpoint = window.matchMedia('(max-width: 599px)');
    let currentTopic = 'all';

    const render = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-juitoy-guide-card]'));
      const onMobile = mobileBreakpoint.matches;
      const mobilePagination = root.dataset.juitoyMobilePagination === 'true';
      const pageSize = onMobile
        ? Math.max(1, Number(root.dataset.juitoyMobilePageSize || 3))
        : Math.max(1, Number(root.dataset.juitoyDesktopPageSize || 6));
      const usePagination = !onMobile || mobilePagination;
      const topic = root.dataset.selectedTopic || currentTopic;
      const matches = cards.filter((card) => topic === 'all' ||
        (card.dataset.juitoyGuideTags || '').includes(`|${topic}|`));
      const pageCount = Math.max(1, Math.ceil(matches.length / pageSize));
      const desiredPage = Number(root.dataset.selectedPage || 0);
      const page = Math.max(0, Math.min(desiredPage, pageCount - 1));
      root.dataset.selectedPage = String(page);

      cards.forEach((card) => { card.hidden = true; });
      (usePagination ? matches.slice(page * pageSize, (page + 1) * pageSize) : matches)
        .forEach((card) => { card.hidden = false; });

      const empty = root.querySelector('[data-juitoy-guide-empty]');
      const controls = root.querySelector('[data-juitoy-article-controls]');
      const previous = root.querySelector('[data-juitoy-article-previous]');
      const next = root.querySelector('[data-juitoy-article-next]');
      const status = root.querySelector('[data-juitoy-article-status]');
      if (empty) empty.hidden = matches.length > 0;
      if (controls) controls.hidden = !usePagination || matches.length <= pageSize;
      if (previous) previous.disabled = page <= 0;
      if (next) next.disabled = page >= pageCount - 1;
      if (status) status.textContent = usePagination && matches.length > pageSize
        ? `${page + 1} / ${pageCount}` : '';
    };

    const init = () => {
      document.querySelectorAll('[data-juitoy-guide-articles]').forEach((root) => {
        if (!root.dataset.selectedTopic) root.dataset.selectedTopic = currentTopic;
        if (!root.dataset.selectedPage) root.dataset.selectedPage = '0';
        render(root);
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-juitoy-article-next], [data-juitoy-article-previous]');
      if (!button) return;
      const root = button.closest('[data-juitoy-guide-articles]');
      if (!root || button.disabled) return;
      root.dataset.selectedPage = String(Number(root.dataset.selectedPage || 0) +
        (button.hasAttribute('data-juitoy-article-next') ? 1 : -1));
      render(root);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        root.scrollIntoView({ block: 'start' });
      }
    });

    document.addEventListener('juitoy:guide-topic-change', (event) => {
      currentTopic = event.detail && event.detail.topic || 'all';
      document.querySelectorAll('[data-juitoy-guide-articles]').forEach((root) => {
        root.dataset.selectedTopic = currentTopic;
        root.dataset.selectedPage = '0';
        render(root);
      });
    });

    if (mobileBreakpoint.addEventListener) mobileBreakpoint.addEventListener('change', init);
    else mobileBreakpoint.addListener(init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juitoy-blog-topics"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__juitoyGuideTopicHandlerV1) return;
    window.__juitoyGuideTopicHandlerV1 = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-juitoy-guide-topics] [data-juitoy-guide-topic]');
      if (!button) return;
      const topic = button.dataset.juitoyGuideTopic || 'all';
      document.querySelectorAll('[data-juitoy-guide-topics] [data-juitoy-guide-topic]').forEach((item) => {
        const selected = item.dataset.juitoyGuideTopic === topic;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      document.dispatchEvent(new CustomEvent('juitoy:guide-topic-change', { detail: { topic } }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
